// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__167It","label":"Labeled_label__3hnvN","divider":"Labeled_divider__MG4nM"};